module.exports = "## Core palette\n\nOur core palette is made up of brand, action, neutral and notification colors.\n"